/**
 * @fileoverview GET handler for the "/apps/business/account_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountFields } from "./constants";
import type { AppsBusinessAccountFieldsResult } from "./types";
import { isAppsBusinessAccountFieldsResult } from "./validators";

export const getAppsBusinessAccountFields = reactQueryFetcherAdapter(
  appsBusinessAccountFields,
  (signal: AbortSignal): Promise<AppsBusinessAccountFieldsResult> => {
    return fetch("/apps/business/account_fields", "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isAppsBusinessAccountFieldsResult
);
